import React, { useEffect, useState } from "react";
import CreateCompany from "./components/CreateCompany";
import CreatePackage from "./components/CreatePackage";
import CreateCocktails from "./components/CreateCocktails";
import CreateAdmin from "./components/CreateAdmin";
import { useLocation, useNavigate } from "react-router";
import ViewPackages from "./components/ViewPackages";
import ViewCocktails from "./components/ViewCocktails";
import CompanyDetail from "./components/details/CompanyDetail";
import BartenderDetail from "./components/details/BartenderDetail";
import { useSearchParams } from "react-router-dom";
import DashboardLayout from "@/layouts/DashboardLayout";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import DashboardHeader from "@/components/DashboardHeader";
import { MdOutlineKeyboardDoubleArrowRight } from "react-icons/md";
import { API_ROUTES } from "@/services/environment";
import { CompanyInterface, UserBartender } from "./interface";
import { GET } from "@/services/api";
import { useAppSelector } from "@/hooks/hook";
import { IoMdArrowBack } from "react-icons/io";
import PriceCalculator from "@pages/company/PriceCalculation2/PriceCalculation"

const Company = () => {
  const { getCompanyApi, businessAdmin, packages } = API_ROUTES;
  const { refreshToken } = useAppSelector((store) => store.user);

  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const isEditState = !!searchParams.get("id");
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id");

  const step = location?.state?.step;
  const isView = location?.state?.isView;
  const isNew = location?.state?.isNew;

  const [currentStep, setCurrentStep] = useState<number>(step ?? 1);
  const [businessId, setBusinessId] = useState<string | null>(id ?? null);
  const [companyData, setCompanyData] = useState<CompanyInterface | null>(null);
  const [adminData, setAdminData] = useState<UserBartender | null>(null);
  const [packagesData, setPackagesData] = useState<Array<any>>([]);

  const next = () => {
    // for next step
    setCurrentStep(currentStep + 1);
  };
  const prev = () => {
    // for previous step
    setCurrentStep(currentStep - 1);
  };

  const addBusinessId = (id: string) => {
    setBusinessId(id);
  };
  useEffect(() => {
    setBusinessId(searchParams.get("id"));
    if (isEditState) {
      const getBusinessData = async () => {
        try {
          const result = await GET(
            `${getCompanyApi}/${businessId}`,
            refreshToken
          );
          //update state for modal
          setCompanyData(result?.data);
        } catch (err) {
          console.log(String(err));
        }
      };
      const getAdminData = async () => {
        try {
          const result = await GET(
            `${businessAdmin}/${businessId}`,
            refreshToken
          );
          const data = result.data.data;
          if (result.data.success === true) {
            setAdminData(data);
          }
        } catch (err) {
          console.log(String(err));
        }
      };
      // get all the packages data from the server
      const getPackages = async () => {
        try {
          const result = await GET(`${packages}/${businessId}`, refreshToken);
          setPackagesData(result.data);
        } catch (err) {
          console.log(err);
        }
      };

      getBusinessData();
      getAdminData();
      getPackages();
    }
  }, [isEditState, currentStep]);
  // },[searchParams.get('id')])

  if (isNew && id) {
    // if new package and new cocktail requires
    return (
      <div>
        {step == 3 && id && <CreatePackage businessId={id} />}
        {step == 4 && id && <CreateCocktails businessId={id} isNew={true} />}
      </div>
    );
  }
  const goBack = () => {
    navigate(-1);
  };
  return isView && businessId ? (
    // view behaviour of company steps
    <div>
      <CompanyDetail next={next} businessId={businessId} />
      <BartenderDetail
        isAdmin={true}
        businessId={id ?? undefined}
        isView={isView}
      />
      <ViewPackages businessId={businessId} />
      <ViewCocktails businessId={businessId} />
      {/* <CreatePackage next={next} prev={prev} businessId={id} isEdit={isView} />
        <CreateCocktails next={next} prev={prev} isEdit={isView} /> */}
    </div>
  ) : (
    <div>
      <div className="flex items-center gap-1 flex-wrap mb-2 sm:mb-0">
        <div className="bg-white p-2 rounded-full cursor-pointer">
          <IoMdArrowBack className=" " onClick={() => goBack()} />
        </div>
        <DashboardHeader title={"Business Profile"}></DashboardHeader>

        <div className="flex  items-center">
          <MdOutlineKeyboardDoubleArrowRight className="text-primary-red" />
          <p
            onClick={() => setCurrentStep(1)}
            className="underline hover:cursor-pointer text-primary-red "
          >
            {companyData?.name}
          </p>
        </div>
        {currentStep >= 2 && adminData && (
          <div className="flex  items-center">
            <MdOutlineKeyboardDoubleArrowRight className="text-primary-red" />
            <p
              onClick={() => setCurrentStep(2)}
              className="underline hover:cursor-pointer text-primary-red "
            >
              {adminData?.first_name}
            </p>
          </div>
        )}
        {currentStep >= 3 && packagesData.length > 0 && (
          <div className="flex  items-center">
            <MdOutlineKeyboardDoubleArrowRight className="text-primary-red" />
            <p
              onClick={() => setCurrentStep(3)}
              className="underline hover:cursor-pointer text-primary-red "
            >
              {packagesData[0]?.name}
            </p>
          </div>
        )}
        {currentStep >= 4 && packagesData.length > 0 && (
          <div className="flex  items-center">
            <MdOutlineKeyboardDoubleArrowRight className="text-primary-red" />
            <p
              onClick={() => setCurrentStep(3)}
              className="underline hover:cursor-pointer text-primary-red "
            >
              Cocktails
            </p>
          </div>
        )}
      </div>
      {/*-create behaviour of company required steps */}
      <ProgressBar currentStep={currentStep} />
      {currentStep === 1 && (
        <CreateCompany next={next} addBusinessId={addBusinessId} />
      )}
      {currentStep === 2 && businessId && (
        <CreateAdmin
          businessId={businessId}
          isAdmin={true}
          next={next}
          prev={prev}
        />
      )}
      {currentStep === 3 && businessId && (
        <PriceCalculator
          params={{
            currentBusiness: businessId,
            isCompanyCreation: true,
            next: next,
            businessName: companyData?.name,
          }}
        />
        // <CreatePackage
        //   isEditState={packagesData.length > 0}
        //   next={next}
        //   prev={prev}
        //   businessId={businessId}
        // />
      )}
      {currentStep === 4 && businessId && (
        <CreateCocktails
          businessId={businessId}
          next={next}
          prev={prev}
          isNew={true}
        />
      )}
    </div>
  );
};

export default Company;

const ProgressBar = ({ currentStep }: { currentStep: number }) => {
  // progress view component
  // const progressPercentage = (currentStep / 4) * 100;

  return (
    <div className="container flex flex-row gap-2 mx-auto lg:px-20 md:px-10 px-5">
      <div className="w-full bg-gray-300 rounded-full h-1 mb-6 ">
        <div
          className="bg-primary-red h-1 rounded-full"
          style={{ width: `${currentStep >= 1 ? "100" : "0"}%` }}
        ></div>
      </div>
      <div className="w-full bg-gray-300 rounded-full h-1 mb-6 ">
        <div
          className="bg-primary-red h-1 rounded-full"
          style={{ width: `${currentStep >= 2 ? "100" : "0"}%` }}
        ></div>
      </div>
      <div className="w-full bg-gray-300 rounded-full h-1 mb-6 ">
        <div
          className="bg-primary-red h-1 rounded-full"
          style={{ width: `${currentStep >= 3 ? "100" : "0"}%` }}
        ></div>
      </div>
      <div className="w-full bg-gray-300 rounded-full h-1 mb-6 ">
        <div
          className="bg-primary-red h-1 rounded-full"
          style={{ width: `${currentStep == 4 ? "100" : "0"}%` }}
        ></div>
      </div>
    </div>
  );
};
